import { Components, Theme } from "@mui/material";

export const MuiTooltip: Components<Omit<Theme, "MuiTooltip">>["MuiTooltip"] = {
  styleOverrides: {
    tooltipPlacementBottom: {
      marginTop: "16px !important",
    },
    tooltip: {
      maxWidth: 400,
      boxShadow: `
          0px 2px 4px 0px #4D4D4D1F,
          0px 7px 7px 0px #4D4D4D1A,
          0px 17px 10px 0px #4D4D4D0F,
          0px 30px 12px 0px #4D4D4D05,
          0px 47px 13px 0px #4D4D4D00,
          0px 0px 5.8px 0px #2E2E2E40
        `,
      backgroundColor: "#fff",
      color: "#000",
      padding: "8px 16px",
      borderRadius: "8px",
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "140%",
      letterSpacing: "-0.02em",
    },
    arrow: {
      color: "#fff",
      "&::before": {
        zIndex: 1,
        boxShadow: "0px 0px 20px 1px #2E2E2E40",
      },
    },
  },
};
